"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _react = _interopRequireWildcard(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

require("../styles/_indicator.scss");

function onClickIndicator(a, b) {
  return function () {
    b(a);
  };
}

function Indicator(a) {
  var b = a.commentId,
      c = a.onClick,
      d = a.colour,
      e = a.leftPercent,
      f = "calc(".concat(e, "% - 3px)"),
      g = d ? {
    left: f,
    backgroundColor: d.color,
    filter: d.brightness
  } : {
    left: f,
    opacity: 0
  };
  return _react["default"].createElement("button", {
    style: g,
    type: "button",
    onClick: onClickIndicator(b, c),
    className: "comment-indicator"
  });
}

var _default = (0, _react.memo)(Indicator);

exports["default"] = _default;